import { Icon, IconsEnum } from 'components/Icons';
import styles from './IppicaNavContentEmpty.module.scss';

export type IppicaNavContentEmptyProps = {
  className?: string;
};

export const IppicaNavContentEmpty = ({ className }: IppicaNavContentEmptyProps) => {
  return (
    <div className={`${styles.container} ${className ? className : ''}`}>
      <Icon iconId={IconsEnum.SEARCH_OFF} className={styles.icon} color={'var(--color-on-bg-primary)'} />
      <p className={styles.text}>Non ci sono corse disponibili in questo momento.</p>
      <p className={styles.text}>Riprova più tardi.</p>
    </div>
  );
};
